import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fau7y3uv8k: FaireBrandEntity = {
  token: "b_fau7y3uv8k",
  type: "brand",
  name: "MIAS SHOP",
  avatarUrl:
    "https://cdn.faire.com/fastly/8458e2595c5dc244ae51b41d1e16b2d1ba84d11dca4fce5b4029b7e2a6ba87b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/05b9aa52947e36e0422596b9352f3442576b5165663bf57c5350575ff046b506.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8458e2595c5dc244ae51b41d1e16b2d1ba84d11dca4fce5b4029b7e2a6ba87b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05b9aa52947e36e0422596b9352f3442576b5165663bf57c5350575ff046b506.jpeg",
  location: "Riverside, CA, USA",
  minimumOrderDollars: 80,
  rating: 4.7,
  reviewCount: 71,
  isInsider: true,
  description:
    "WELCOME to MIAS SHOP !!!\nHere at MIAS SHOP we have a variety of toys, tools, and other cool stuff. They are all self regulation tools to help with attention, focus, active listening, and calming. We are here to help in any way possible to make our lifes much more enjoyable!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:34.463Z",
    importedBy: "entity-db-cli",
  },
};
